import React from 'react';
import PropTypes from 'prop-types';
import { AdditionalToolsContent } from './AdditionalToolsContent';

export const AdditionalTools = ({ isContentLoaded }) => {
  return (
    <Choose>
      <When condition={isContentLoaded}>
        <AdditionalToolsContent />
      </When>
    </Choose>
  );
};

AdditionalTools.propTypes = {
  isContentLoaded: PropTypes.bool,
};

AdditionalTools.defaultProps = {
  isContentLoaded: false,
};
